<template>
  <svg viewBox="0 0 1199 1722" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M400 919h390v-89H539c14-26 51-59 110-97 73-49 136-96 136-195 0-107-82-173-185-173-128 0-192 77-192 202h101c2-58 23-110 89-110 51 0 75 37 75 85 0 45-28 74-62 100-9 8-22 18-40 31-19 13-32 23-40 30-71 54-128 122-131 216zm199-795c292 0 528 236 528 528 0 291-236 528-528 528-291 0-528-237-528-528 0-292 237-528 528-528z" />
  </svg>
</template>
